import { Shield } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export const DashboardHeader = () => {
  const { user } = useAuth();
  
  return (
    <header className="border-b border-white/10 bg-[#222222]/95 backdrop-blur supports-[backdrop-filter]:bg-[#222222]/60 fixed top-0 right-0 left-64 z-40">
      <div className="flex h-16 items-center justify-between py-4 px-8">
        <div className="flex items-center gap-4">
          <Shield className="h-8 w-8 text-primary" />
          <span className="text-xl font-bold text-white">Tradeco Financial Realignment Services</span>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-sm text-gray-300">
            Welcome, {user?.email?.split('@')[0] || 'Guest'}
          </span>
        </div>
      </div>
    </header>
  );
};